"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleErrorWithRedirect = exports.handleAuthenticationRedirect = exports.getCurrentUrlWithoutContextPath = void 0;
const URL_PARAM_LENGTH_LIMIT = 1200;
const isAuthenticationError = (errorCode) => [401, 403].includes(errorCode);
const getCurrentUrlWithoutContextPath = () => {
    const url = window.location.pathname.replace(currentContextPath, "");
    // reduce Request header length
    if (window.location.search.length > URL_PARAM_LENGTH_LIMIT) {
        return url;
    }
    return url + window.location.search;
};
exports.getCurrentUrlWithoutContextPath = getCurrentUrlWithoutContextPath;
const handleAuthenticationRedirect = (error) => {
    if (error.response?.status && isAuthenticationError(error.response.status)) {
        const url = error.response?.data?.redirectUrl;
        window.location.href = url || `${currentContextPath}/my-account/sign-in/`;
    }
};
exports.handleAuthenticationRedirect = handleAuthenticationRedirect;
const handleErrorWithRedirect = (axiosError) => {
    if (!axiosError.config?.handleErrorWithRedirect) {
        return;
    }
    const statusCode = axiosError.response?.status;
    if (statusCode === 500) {
        window.location.replace(`${currentContextPath}/error/500/`);
    }
    if (statusCode === 404) {
        window.location.replace(`${currentContextPath}/error/404/`);
    }
};
exports.handleErrorWithRedirect = handleErrorWithRedirect;
